<script lang="ts">
  // A LIRR / Metro-North branch badge: the branch code on a landscape tag in the branch's
  // own colour, with a white bar across the top — the DOM twin of `createRailBadge` on the
  // map, so a train on the map and its row in a sheet are the same shape. Custom for the
  // reason RouteBadge is (see artifacts/deviations): the shape is data, and a subway disc
  // or a bus pill would claim the train belongs to a different system.
  import { getRouteColor, getRouteTextColor, routeBadgeLabel } from '../ui/colors'
  import { BULLET_TYPE } from '../ui/theme'

  interface Props {
    routeId: string
    /** Height in px; the tag is 4:3. */
    size?: number
  }

  const { routeId, size = 24 }: Props = $props()
  const width = $derived(Math.round((size * 4) / 3))
  const bar = $derived(Math.max(2, Math.round(size / 7)))
</script>

<span
  style="
    display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0;
    box-sizing: border-box; width: {width}px; height: {size}px;
    padding-top: {bar}px; border-radius: {Math.max(2, size / 9)}px;
    background: linear-gradient(#fff 0 {bar}px, {getRouteColor(routeId)} {bar}px);
    color: {getRouteTextColor(routeId)};
    {BULLET_TYPE}; font-size: {Math.round(size * 0.46)}px; line-height: 1;
  "
>{routeBadgeLabel(routeId)}</span>
